export default __webpack_public_path__ + "static/media/(24).80e7bc5b.JPG";